module.exports = __webpack_public_path__ + "static/media/website.e71de35f.png";